
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/teams/[team]/login",
      function () {
        return require("private-next-pages/teams/[team]/login.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/teams/[team]/login"])
      });
    }
  